import { useCallback, useState } from "react";
import { UseCustomDialogReturn } from "../CustomDialog.types";

/**
 * Custom hook for managing dialog state
 * @param initialOpen - Initial open state of the dialog
 * @returns Object with dialog state and control functions
 */
export const useCustomDialog = (initialOpen = false): UseCustomDialogReturn => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((prev) => !prev), []);

  return { isOpen, open, close, toggle };
};
